import { HIWContentCardContainer, HIWContentCardLine } from './styledComponents'

export default function ContentCard({ index, title, description }) {
  return (
    <HIWContentCardContainer>
      {title && (
        <h2 className="main-heading">
          {index && <span className="index-heading">{String(index).padStart(2, '0')}</span>}
          {title}
        </h2>
      )}
      <HIWContentCardLine />
      {description && <h4 className="description">{description}</h4>}
    </HIWContentCardContainer>
  )
}
